import { format } from 'date-fns';
import zonedDate from './zoned-date';

const NBSP = String.fromCharCode(160);
const DBNBSP = String.fromCharCode(160, 160);

function applyMonthAbbreviations(str) {
    return str
        .replace('Jun', 'June')
        .replace('Jul', 'July')
        .replace('Sep', 'Sept');
}

export default function (date) {
    date = date instanceof Date ? date : zonedDate(date);

    const day = format(date, 'EEE');
    const month = applyMonthAbbreviations(format(date, 'MMM'));
    const dom = format(date, 'd');
    const year = format(date, 'yyyy');
    const time = date.getMinutes()
        ? format(date, 'h:mmaa')
        : format(date, 'haa');

    return day + DBNBSP + month + NBSP + dom + ',' + NBSP + year + DBNBSP + time;
}
